export default {
	created() {
		let outer = document.createElement("div");
		outer.style.visibility = "hidden";
		outer.style.overflow = "scroll";
		outer.style.msOverflowStyle = "scrollbar";
		document.body.appendChild(outer);
		let inner = document.createElement("div");
		outer.appendChild(inner);
		let scrollbarSize = (outer.offsetWidth - inner.offsetWidth);
		outer.parentNode.removeChild(outer);
		document.documentElement.style.setProperty("--scroll-size", scrollbarSize + "px");
	},
};
